// Tabs.jsx
import React, { useEffect, useMemo, useState } from 'react'

const getTabsItems = (itemsType) => {
    switch (itemsType) {
        case 'main':
            return [
                { value: 'all', text: 'Основное' },
                { value: 'analytics', text: 'Аналитика' },
            ]

        case 'application':
            return [
                { value: 'all', text: 'Все' },
                { value: 'ordered', text: 'Оформленные' },
                { value: 'processing', text: 'На рассмотрении' },
                { value: 'confirmed', text: 'Подтверждённые' },
                { value: 'rejected', text: 'Отклонённые' },
            ]

        case 'products':
            return [
                { value: 'all', text: 'Все' },
                { value: 'nothing', text: 'Ничего' },
                { value: 'inProgress', text: 'В работе' },
                { value: 'modelReady', text: 'Модель готова' },
                { value: 'productInfo', text: 'Инфо по товару' },
                { value: 'photosUploaded', text: 'Фото загружены' },
            ]

        case 'adminBilling':
            return [
                { value: 'promos', text: 'Промокоды' },
                { value: 'transactions', text: 'Транзакции' },
                { value: 'settings', text: 'Настройки биллинга' },
            ]

        default:
            return [
                { value: 'all', text: 'Все' },
                { value: 'ordered', text: 'Новые' },
                { value: 'confirmed', text: 'Подтверждённые' },
                { value: 'work', text: 'Производство' },
                { value: 'shipped', text: 'Передан в службу доставки' },
                { value: 'delivered', text: 'Доставленные' },
            ]
    }
}

export const Tabs = ({
    setValueTabsSort,
    itemsType,
    items,
    value,
    onChange,
    ariaLabel = 'Разделы',
}) => {
    const resolvedItems = useMemo(() => {
        if (Array.isArray(items) && items.length) {
            return items
        }

        return getTabsItems(itemsType)
    }, [items, itemsType])

    const [internalValue, setInternalValue] = useState(() => resolvedItems[0]?.value || '')

    useEffect(() => {
        if (value !== undefined) return

        const stillExists = resolvedItems.some(item => item.value === internalValue)

        if (!stillExists) {
            setInternalValue(resolvedItems[0]?.value || '')
        }
    }, [resolvedItems, internalValue, value])

    const activeValue = value !== undefined
        ? value
        : internalValue

    const handleValueSort = (nextValue) => {
        if (value === undefined) {
            setInternalValue(nextValue)
        }

        if (typeof onChange === 'function') {
            onChange(nextValue)
        }

        if (typeof setValueTabsSort === 'function') {
            setValueTabsSort(nextValue)
        }
    }

    if (!resolvedItems.length) return null

    return (
        <div className="tabs">
            <div className="tabs__container">
                <div
                    className="tabs__list"
                    role="tablist"
                    aria-label={ariaLabel}
                >
                    {resolvedItems.map((item) => {
                        const isActive = activeValue === item.value

                        return (
                            <button
                                type="button"
                                role="tab"
                                aria-selected={isActive}
                                className={isActive ? 'tabs__item active' : 'tabs__item'}
                                onClick={() => handleValueSort(item.value)}
                                key={item.value}
                            >
                                <span className="tabs__link">{item.text}</span>
                                {item.badge !== undefined && item.badge !== null && item.badge !== 0 ? (
                                    <span className="tabs__badge">{item.badge}</span>
                                ) : null}
                            </button>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}
